import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparison() {
  return <section className="py-20 bg-white px-4" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <div className="text-center mb-16" data-id="element-38">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-39">
            La realidad: ¿cuánto cuesta no tenerlo?
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto" data-id="element-40">
            Seguir publicando sin estrategia tiene un costo real que la mayoría
            no calcula.
          </p>
        </div>

        <div className="flex flex-col md:flex-row rounded-3xl overflow-hidden shadow-2xl" data-id="element-41">
          <div className="w-full md:w-1/2 bg-red-50 p-8 md:p-12" data-id="element-42">
            <div className="flex items-center gap-3 mb-8" data-id="element-43">
              <div className="bg-red-100 p-2 rounded-full text-red-500" data-id="element-44">
                <X className="w-6 h-6" data-id="element-45" />
              </div>
              <h3 className="text-2xl font-bold text-red-900" data-id="element-46">
                Sin el sistema:
              </h3>
            </div>

            <ul className="space-y-6" data-id="element-47">
              <li className="flex items-start gap-3 text-red-800" data-id="element-48">
                <span className="text-xl" data-id="element-49">😤</span>
                <span data-id="element-50">Publicás todos los días sin que nadie compre</span>
              </li>
              <li className="flex items-start gap-3 text-red-800" data-id="element-51">
                <span className="text-xl" data-id="element-52">⏱️</span>
                <span data-id="element-53">3-5 hs por semana buscando qué publicar en YouTube</span>
              </li>
              <li className="flex items-start gap-3 text-red-800" data-id="element-54">
                <span className="text-xl" data-id="element-55">💸</span>
                <span data-id="element-56">Plata en publicidad que no convierte</span>
              </li>
              <li className="flex items-start gap-3 text-red-800" data-id="element-57">
                <span className="text-xl" data-id="element-58">🤷</span>
                <span data-id="element-59">Sin saber cómo hablarle a tu cliente</span>
              </li>
              <li className="flex items-start gap-3 text-red-800" data-id="element-60">
                <span className="text-xl" data-id="element-61">😰</span>
                <span data-id="element-62">Cerrás ventas mal o las perdés en los DMs</span>
              </li>
              <li className="flex items-start gap-3 text-red-800" data-id="element-63">
                <span className="text-xl" data-id="element-64">📉</span>
                <span data-id="element-65">Ventas que dependen del boca a boca</span>
              </li>
              <li className="flex items-start gap-3 text-red-800" data-id="element-66">
                <span className="text-xl" data-id="element-67">😔</span>
                <span data-id="element-68">Fin de mes frustrante, sin resultados visibles</span>
              </li>
            </ul>
          </div>

          <div className="w-full md:w-1/2 bg-navy p-8 md:p-12 text-white" data-id="element-69">
            <div className="flex items-center gap-3 mb-8" data-id="element-70">
              <div className="bg-sky/20 p-2 rounded-full text-sky" data-id="element-71">
                <Check className="w-6 h-6" data-id="element-72" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-73">Con el sistema:</h3>
            </div>

            <ul className="space-y-6" data-id="element-74">
              <li className="flex items-start gap-3 text-slate-200" data-id="element-75">
                <span className="text-xl" data-id="element-76">🎯</span>
                <span data-id="element-77">Estrategia de contenido lista en 7 días</span>
              </li>
              <li className="flex items-start gap-3 text-slate-200" data-id="element-78">
                <span className="text-xl" data-id="element-79">⚡</span>
                <span data-id="element-80">
                  30 ideas de contenido listas, sin pensar qué publicar
                </span>
              </li>
              <li className="flex items-start gap-3 text-slate-200" data-id="element-81">
                <span className="text-xl" data-id="element-82">📈</span>
                <span data-id="element-83">Meta Ads configurado para no desperdiciar inversión</span>
              </li>
              <li className="flex items-start gap-3 text-slate-200" data-id="element-84">
                <span className="text-xl" data-id="element-85">💬</span>
                <span data-id="element-86">
                  El lenguaje exacto que convierte tu audiencia en compradores
                </span>
              </li>
              <li className="flex items-start gap-3 text-slate-200" data-id="element-87">
                <span className="text-xl" data-id="element-88">🤝</span>
                <span data-id="element-89">Scripts para cerrar ventas por DM desde hoy</span>
              </li>
              <li className="flex items-start gap-3 text-slate-200" data-id="element-90">
                <span className="text-xl" data-id="element-91">🔄</span>
                <span data-id="element-92">Sistema que trae compradores de forma constante</span>
              </li>
              <li className="flex items-start gap-3 text-slate-200" data-id="element-93">
                <span className="text-xl" data-id="element-94">🚀</span>
                <span data-id="element-95">Primeros resultados visibles antes de los 30 días</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}